import MAIN from './MAIN';
import HomeService from './HomeService';
import Performance from './Performance';
import HomeVideo from './HomeVideo';
import HomeAbout from './HomeAbout';
import Message from '../Message';
import { useEffect } from 'react';



function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <MAIN />
      <HomeService />
      <HomeVideo />
      <Performance />
      <HomeAbout />
      <Message />
    </>
  );
}

export default Home;